<div class="file-item">
    <ec-icon [icon]="icon" class="icon"></ec-icon>
    <span class="file-name">{{ file.name }}</span>
    <button id="file-upload-remove-button" class="remove-button" (click)="remove.emit(index)">✖</button>
</div>
